export default {
      id: "secure-money-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#secure-money",
      toString: function () {
        return this.url;
      }
    }